"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tableau = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const TableauSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#E8762C",
    d: "M15 10.973h-2.508V8h-.984v2.973H9v1.054h2.508V15h.984v-2.973H15z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#C62036",
    d: "M10 16.602H7.475V14H6.52v2.602H4v.796h2.52V20h.955v-2.602H10z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#5A869A",
    d: "M20 6.615h-2.52V4h-.96v2.615H14v.792h2.52V10h.96V7.407H20z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#5C6691",
    d: "M14 19.095h-1.613V17h-.774v2.095H10v.805h1.613V22h.774v-2.1H14z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#EB9028",
    d: "M10 6.615H7.447V4h-.894v2.615H4v.77h2.553V10h.894V7.385H10z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#5C6691",
    d: "M22 11.676h-1.616V10h-.768v1.676H18v.648h1.616V14h.768v-1.676H22z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#1E457E",
    fillRule: "evenodd",
    d: "M20 16.602h-2.52V14h-.96v2.602H14v.796h2.52V20h.96v-2.602H20z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#7098A4",
    d: "M11.693 2v1.735H10v.525h1.693V6h.614V4.26H14v-.525h-1.693V2zM6 11.724H4.3V10h-.6v1.724H2v.552l1.7-.008V14h.6v-1.737l1.7-.009z"
  })]
});
const Tableau = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: TableauSvg
}));
exports.Tableau = Tableau;